import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../commons/Auth';
import {
  BilledField,
  CurrencyField,
  DataTable,
  DateTimeField,
  Field,
  PercentageField,
} from '../../../commons/DataTable';
import IAFCustomCheckboxesSignals from '../../../commons/Checkboxes/IAFCustomCheckboxesSignals';
import { withRouter } from 'react-router-dom';
import SignalmanField from '../../../commons/DataTable/SignalmanField';
import ReportingTypeField from '../../../commons/DataTable/ReportingTypeField';
import FieldIafNumber from '../../../commons/DataTable/FieldIafNumber';

function SignalsRoyaltyTable({
  dataTable,
  data,
  total = 0,
  query = {},
  onFilter,
  isLoading,
  bottomRow,
  truncateTable,
  showEmptyTableMessage,
  allowedRoles = [],
  onSelectChange,
  profile,
}) {
  const [t] = useTranslation('COMMON');
  const [{ newIsAdmin }] = useAuth();
  const { offset, limit } = query;

  const onCheck = (report) => {
    if (!allowedRoles.includes('superadmin')) {
      return;
    }
    onSelectChange(report);
  };

  return (
    <DataTable
      offset={offset}
      limit={limit}
      total={total}
      dataTable={dataTable}
      data={data}
      isLoading={isLoading}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      onFilter={onFilter}
      bottomRow={bottomRow}
      showEmptyTableMessage={showEmptyTableMessage}
    >
      <IAFCustomCheckboxesSignals
        onSelectChange={onCheck}
        onClick={(e) => e.stopPropagation()}
        profile={profile}
        visible={!truncateTable && newIsAdmin}
      />
      <SignalmanField
        title="Ruolo"
        source="signalmanPosition"
        className="text-left"
        visible={!truncateTable}
      />
      <ReportingTypeField
        title="Tipo rendicontazione"
        source="reportingType"
        className="text-left"
        visible={!truncateTable}
      />
      <Field
        title="Beneficiario"
        source="adminInfo.businessName"
        className="text-left"
        visible={!truncateTable}
      />
      <Field
        title="Beneficiario P.iva/Codice Fiscale"
        source="adminInfo.taxCode"
        className="text-left"
        visible={!truncateTable}
      />
      <DateTimeField
        title="Data rendicontazione"
        source="accountabilityDate"
        className="text-left"
        format="DD/MM/YYYY"
        visible={!truncateTable}
      />
      <CurrencyField
        title="Totale fattura"
        source="estimate"
        className="txt-table-right"
        visible={!truncateTable}
      />
      <PercentageField
        title="Quota extra %"
        source="extraPercentage"
        className="txt-table-right"
        visible={!truncateTable && newIsAdmin}
      />
      <CurrencyField
        title="Quota extra"
        source="extraShare"
        className="txt-table-right"
        visible={!truncateTable && newIsAdmin}
      />
      <PercentageField
        title="Quota Segnalatore %"
        source="calculateAdminPerc"
        className="txt-table-right"
        visible={!truncateTable}
      />
      <CurrencyField
        title="Quota Segnalatore"
        source="adminShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Quota responsabile maturata"
        source="earnedAdminShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Diritto a Fatturare"
        source="billableAdminShare"
        className="txt-table-right"
      />
      <BilledField
        title="Invitato a Fatturare"
        className="txt-table-right"
        visible={!truncateTable}
      />
      <FieldIafNumber
        title="Numero IAF"
        className="txt-table-right"
        source="iaf.number"
        visible={!truncateTable}
      />
    </DataTable>
  );
}

export default withRouter(SignalsRoyaltyTable);
